// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2aiXj9","inline":"_2nSOdc","block":"_9BmPn1","fullWidth":"_2-jYOE","trigger":"_3Xwxw7","button":"_3HzdBz","icon":"-Tu1fn","icon--disabled":"_3s7n7V"};